import { Checkbox } from "@nextui-org/react";
const explanationBasedcolumn = [
  {
    key: "num",
    label: "SN.",
  },
  {
    key: "date",
    label: "Date",
  },
  {
    key: "examName",
    label: "Exam",
  },
  {
    key: "totalMcq",
    label: "Total Qs",
  },
  
  {
    key: "actions",
    label: "Action",
  },
];

export { explanationBasedcolumn };
